// extracted by mini-css-extract-plugin
module.exports = {"maxMobile":"1024px"};